// @mui
import PropTypes from 'prop-types';
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';

// utils
import { fShortenNumber } from '../../../utils/formatNumber';
import { Link } from 'react-router-dom';
// components

// ----------------------------------------------------------------------

const IconWrapper = styled('div')`
  .MuiSvgIcon-root {
    font-size: 40px;
  }
`;

// ----------------------------------------------------------------------

AppWidgetSummary.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.any,
  title: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  sx: PropTypes.object,
  to: PropTypes.string,
};

export default function AppWidgetSummary({ title, total, icon, color = 'primary', sx, to, ...other }) {
  return (
    <Link
      to={to}
      style={{
        textDecoration: 'none',
      }}
    >
      <Card
        sx={{
          py: 5,
          boxShadow: 0,
          textAlign: 'center',
          color: (theme) => theme.palette[color].darker,
          bgcolor: (theme) => theme.palette[color].lighter,
          ...sx,
        }}
        {...other}
      >
        <IconWrapper>{icon}</IconWrapper>
        <Typography variant="h3">{fShortenNumber(total)}</Typography>

        <Typography variant="h4" sx={{ opacity: 0.72 }}>
          {title}
        </Typography>
      </Card>
    </Link>
  );
}
